<template>
  <div>
    <h3>Does either of your biological parents have a history of diabetes?</h3>
    <v-form-group class="card-selector" :validator="$v.parentsDiabet">
      <b-form-checkbox v-model="survey.parentsDiabet.isMother" @change="(value) => setOptions(value, survey.parentsDiabet.isFather, false, false)">
        <svg-icon name="mother" /> Mother
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.parentsDiabet.isFather" @change="(value) => setOptions(survey.parentsDiabet.isMother, value, false, false)">
        <svg-icon name="father" /> Father
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.parentsDiabet.isDontKnow" @change="(value) => setOptions(false, false, value, false)">
        <svg-icon name="dk" /> Don't know
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.parentsDiabet.isNeither" @change="(value) => setOptions(false, false, false, value)">
        <svg-icon name="like" /> Neither Mother nor Father
      </b-form-checkbox>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";

  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  import { anyOptionRequired } from 'utils/custom-validators';

  export default {
    mixins: [formMixin],

    validations: {
      parentsDiabet: {
        anyOptionRequired: anyOptionRequired((value) => value.isMother || value.isFather || value.isDontKnow || value.isNeither)
      }
    },

    computed: {
      ...mapState(["survey"]),

      parentsDiabet() { return this.survey.parentsDiabet }
    },

    methods: {
      onSubmit() {

      },

      setOptions(isMother, isFather, isDontKnow, isNeither) {
        this.survey.parentsDiabet.isMother = isMother;
        this.survey.parentsDiabet.isFather = isFather;
        this.survey.parentsDiabet.isDontKnow = isDontKnow;
        this.survey.parentsDiabet.isNeither = isNeither;
      }
    }
  };
</script>